module.exports = __webpack_public_path__ + "img/logo_loading.svg";